import {
    forwardRef,
    useImperativeHandle,
    useState,
} from 'react'

const SummaryOfYourRightsUnderFcra = forwardRef(({ data, refToPrint }, ref) => {

    const [agreeRights, setAgreeRights] = useState(data?.agreeRights ?? false)
    const [error, setError] = useState('')

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            let isValid = true

            if (!agreeRights) {
                setError('You need to acknowledge the FCRA Disclosure and Summary of Rights')
                isValid = false
            }

            if (isValid) {
                setError('')
            }

            return {
                isValid,
                value: {
                    agreeRights,
                },
            }
        },
    }))

    return (
        <div ref={refToPrint} className="max-w-3xl mx-auto px-4 py-10">

            {/* ── SECTION 1: FCRA RIGHTS ── */}
            <div className="flex flex-col w-full space-y-6">
                <h1 className="text-2xl font-bold text-gray-800 text-center">
                    A Summary of Your Rights Under the FCRA
                </h1>

                <p className="text-gray-700 text-sm sm:text-base">
                    The federal Fair Credit Reporting Act (FCRA) promotes the accuracy, fairness, and privacy
                    of information in the files of consumer reporting agencies. The following is a summary of
                    your rights under the FCRA. Please read each point carefully.
                </p>

                <div className="space-y-4 text-gray-700 text-sm sm:text-base">
                    <ul className="list-disc list-inside space-y-2">
                        <li>
                            <strong>You must be told if information in your file has been used against you.</strong>{' '}
                            Anyone who uses a consumer report to deny your application for employment — including
                            the decision to not proceed with an interview — must tell you and provide the contact
                            information of the agency <strong>(VerifiedID LLC and its authorized agents)</strong> that
                            provided the report.
                        </li>
                        <li>
                            <strong>You have the right to know what is in your file.</strong> You may request and
                            obtain all the information about you in the files of a consumer reporting agency.
                        </li>
                        <li>
                            <strong>You have the right to dispute incomplete or inaccurate information.</strong> If
                            you identify information in your file that is inaccurate, the agency must investigate.
                        </li>
                        <li>
                            <strong>You must give your consent for reports to be provided to employers.</strong>
                        </li>
                    </ul>

                    <p>
                        For more information about your rights under the FCRA, visit{' '}
                        <a href="https://www.consumerfinance.gov/learnmore" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                            www.consumerfinance.gov/learnmore
                        </a>.
                    </p>

                    <label className="flex items-start space-x-2">
                        <input
                            type="checkbox"
                            className="mt-1"
                            checked={agreeRights}
                            onChange={(e) => setAgreeRights(e.target.checked)}
                        />
                        <span>I ACKNOWLEDGE that I have received the FCRA Disclosure and the Summary of My Rights.</span>
                    </label>
                </div>
            </div>

            {error && (
                <p className="mt-1 text-sm text-red-600">{error}</p>
            )}
        </div>
    )
})

export default SummaryOfYourRightsUnderFcra
